import { render } from "./ArtworkImagePopup.vue?vue&type=template&id=6e73bf34&scoped=true&ts=true"
import script from "./ArtworkImagePopup.vue?vue&type=script&lang=ts"
export * from "./ArtworkImagePopup.vue?vue&type=script&lang=ts"

import "./ArtworkImagePopup.vue?vue&type=style&index=0&id=6e73bf34&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e73bf34"]])

export default __exports__